





























































































































































import Vue, { VueConstructor } from 'vue'
import VueRecaptcha from 'vue-recaptcha'
import { mapState } from 'vuex'

import { authentication, app } from '@microsoft/teams-js'
import Util from '@/util'
import Config from '@/config'
import cookie from '@/services/cookie'
import { State, TMapState } from '@/vuex/store'
import { PRESENTER_LOGIN } from '@/constant/gaCategories'

import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import BackDrop from '@/components-v2/common/auth/BackDrop.vue'
import GoogleButtonV2 from '@/components-v2/common/auth/GoogleButtonV2.vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    recaptcha: VueRecaptcha,
  };
}>).extend({
  name: 'Login',
  components: {
    VueRecaptcha,
    BackDrop,
    GoogleButtonV2,
    PublicAnnouncement,
  },
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: true,
      textError: '',
      submitting: false,
      keyRecaptcha: Config.keyRecapcha,
      tokenRecaptcha: '',
      showPassword: false,
      isGuest: false,
      isFromMSTeams: false,
    }
  },
  computed: {
    ...mapState<State, TMapState>({
      isPresenterWhiteLabel: (state: State) => state.isPresenterWhiteLabel,
    }),
    inviterName(): string | null {
      return Util.getParamValue('inviter-name', window.location.href)
    },
    inviterEmail(): string | null {
      return Util.getParamValue('inviter-email', window.location.href)
    },
    sharedPresentationName(): string | null {
      return Util.getParamValue('shared-presentation', window.location.href)
    },
    isDisabled(): boolean {
      return !(this.email || this.password)
    },
  },
  async created() {
    const isFromMSTeams = Util.getParamValue('ms_teams', window.location.href)
    if (isFromMSTeams) {
      await app.initialize()
    }
    this.isGuest = !!cookie.getValue('aha-guest-user')
    if (cookie.getValue('ahaToken') && !this.isGuest) {
      if (isFromMSTeams) {
        authentication.notifySuccess()
      }
      this.$router.push('/apps/presentations')
    }
  },
  mounted() {
    document.body.classList.remove('no-scroll')
    Util.gaTrackEvent(
      PRESENTER_LOGIN,
      'Open login form',
    )
    const isFromMSTeams = !!Util.getParamValue('ms_teams', window.location.href)

    this.isFromMSTeams = isFromMSTeams
  },
  methods: {
    onVerify(response: string) {
      this.tokenRecaptcha = response
      this.login()
    },
    onSubmitLogin() {
      if (this.submitting) return
      this.submitting = true
      if (this.email.match(/qa\.ahaslides\+(.*)@gmail.com/i)) {
        this.login()
      } else {
        this.$refs.recaptcha.execute()
        Util.removeRecaptchaCover()
      }
    },
    onExpired() {
      this.$refs.recaptcha.reset()
      this.tokenRecaptcha = ''
    },
    setLang(lang: string) {
      this.$store.dispatch('setLang', lang)
    },

    onRecaptchaError() {
      this.submitting = false
      this.textError = 'Recaptcha error. If the problem still occurs, please check your internet connection.'
    },

    goSignup() {
      const content = Util.getParamValue('content', window.location.href)
      const source = Util.getParamValue('source', window.location.href)
      const promo = Util.getParamValue('promo', window.location.href)
      const redirect = Util.getParamValue('redirect', window.location.href)

      let query: {
        promo?: string;
        content?: string;
        redirect?: string;
        source?: string;
        ms_teams?: string;
      } = {}

      if (content && source === 'pricing') {
        query = {
          content,
          source,
        }

        if (promo) {
          query.promo = promo
        }
      }

      if (this.isFromMSTeams) {
        query.ms_teams = 'true'
      }

      if (redirect) {
        query.redirect = redirect
      }

      this.$router.push({
        path: '/pages/register',
        query,
      })
    },

    login() {
      // eslint-disable-next-line promise/catch-or-return
      this.$http
        .post(Config.api.login, {
          email: this.email,
          password: this.password,
          tokenRecaptcha: this.tokenRecaptcha,
        })
        .then(
          (res: any) => {
            this.submitting = false
            this.$store.dispatch('setCurrentUserAction', res.body.user)
            Util.setCookieToken(res.body.token)
            if (this.isGuest) {
              cookie.deleteValue('aha-guest-user')
            }

            Object.assign(this.$http.headers, {
              common: { Authorization: `Bearer ${res.body.token}` },
            })
            const redirect = Util.getParamValue('redirect', window.location.href)
            Util.gaTrackEvent(
              PRESENTER_LOGIN,
              'Login Button > Submit > Succeeded',
              '',
            )

            Util.ga4Track('login', {
              method: 'with form login',
            })
            const { user } = res.body
            Util.ga4Config({
              user_id: user.id,
            })

            const content = Util.getParamValue('content', window.location.href)
            const source = Util.getParamValue('source', window.location.href)
            if (this.isFromMSTeams) {
              authentication.notifySuccess(res.body.token)
            }
            let isPlan = false
            if (
              content === 'essential_annually' ||
              content === 'pro_annually' ||
              content === 'essential_monthly' ||
              content === 'pro_monthly' ||
              content === 'plus_monthly' ||
              content === 'plus_annually' ||
              content === 'edu_small' ||
              content === 'edu_medium' ||
              content === 'edu_large' ||
              content === 'one_time_mini' ||
              content === 'one_time_small' ||
              content === 'one_time_medium' ||
              content === 'one_time_large'
            ) {
              isPlan = true
            }
            // eslint-disable-next-line promise/always-return
            if (source === 'pricing' && isPlan) {
              let plan = 'pro-yearly'
              if (content === 'essential_annually') {
                plan = 'essential-yearly'
              }
              if (content === 'essential_monthly') {
                plan = 'essential-monthly'
              }
              if (content === 'pro_monthly') {
                plan = 'pro-monthly'
              }
              if (content === 'plus_monthly') {
                plan = 'plus-monthly'
              }
              if (content === 'plus_annually') {
                plan = 'plus-yearly'
              }
              if (content === 'edu_small') {
                plan = 'edu-small-yearly'
              }
              if (content === 'edu_medium') {
                plan = 'edu-medium-yearly'
              }
              if (content === 'edu_large') {
                plan = 'edu-large-yearly'
              }
              if (content === 'one_time_mini') {
                plan = 'one-time-mini'
              }
              if (content === 'one_time_small') {
                plan = 'one-time-small'
              }
              if (content === 'one_time_medium') {
                plan = 'one-time-medium'
              }
              if (content === 'one_time_large') {
                plan = 'one-time-large'
              }
              const promo = Util.getParamValue('promo', window.location.href)
              let urlRedirect =
                `${Config.presenterDomain}/apps/upgrade/${plan}`
              if (promo) {
                urlRedirect = `${urlRedirect}?promo=${promo}`
              }
              window.location.href = urlRedirect
            } else if (redirect) {
              window.location.href = redirect
            } else {
              this.$router.push('/apps/presentations')
            }
            localStorage.removeItem('blockAudiences')
          },
          (err) => {
            this.submitting = false
            this.$refs.recaptcha.reset()
            if (err.body.message) {
              this.textError = err.body.message
            } else {
              this.textError = 'default_error'
            }
            Util.gaTrackEvent(
              PRESENTER_LOGIN,
              'Login Button > Submit > Failed',
              JSON.stringify(err.body),
            )
          },
        )

      Util.gaTrackEvent(
        PRESENTER_LOGIN,
        'Login Button > Submit',
        '',
      )
    },

    registerUser() {
      this.$router.push('/pages/register')
    },

    handleLoginWithSso() {
      this.$router.push('/pages/sso')
    },
  },
})
